import { lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStoreCart } from '../../context/StoreCartContext';
import { useFeatureFlags } from '../../context/FeatureFlagsContext';
import { FEATURE_KEYS } from '../../utils/featureFlags';

const StoreCartDrawer = lazy(() =>
  import(/* webpackChunkName: "store-cart-drawer" */ '../StoreCartDrawer/StoreCartDrawer')
);
const StoreCheckoutDialog = lazy(() =>
  import(/* webpackChunkName: "store-checkout" */ '../StoreCheckoutDialog/StoreCheckoutDialog')
);

export default function StoreCartHost() {
  const { flags } = useFeatureFlags();
  const navigate = useNavigate();
  const {
    isDrawerOpen,
    checkoutItems,
    checkoutOpen,
    openCheckout,
    closeCheckout,
    clearCart,
  } = useStoreCart();

  const handleCheckoutSuccess = ({ orderId, orderNumber, confirmData }) => {
    closeCheckout();
    clearCart();
    const qs = orderNumber ? `?orderNumber=${encodeURIComponent(orderNumber)}` : '';
    navigate(`/store/thank-you/${orderId}${qs}`, { replace: true, state: { confirmData } });
  };

  if (!flags[FEATURE_KEYS.WEB_STORE]) return null;

  const mountStoreUi = isDrawerOpen || checkoutOpen;

  return (
    <Suspense fallback={null}>
      {mountStoreUi ? <StoreCartDrawer onCheckout={openCheckout} /> : null}
      {checkoutOpen ? (
        <StoreCheckoutDialog
          cartItems={checkoutItems}
          open={checkoutOpen}
          onClose={closeCheckout}
          onSuccess={handleCheckoutSuccess}
        />
      ) : null}
    </Suspense>
  );
}
